import { initializeApp, type FirebaseApp } from "firebase/app";
import {
  getAuth,
  isSignInWithEmailLink,
  sendSignInLinkToEmail,
  signInWithEmailLink,
  signInWithEmailAndPassword,
  signOut,
  type Auth,
  type User
} from "firebase/auth";

const EMAIL_FOR_SIGN_IN_KEY = "ceduc.engajamento.emailForSignIn";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyCkrnhBlGZ1V8otpCf4VnurZ2RiM4q84Bk",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "ceduc-mackenzie.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "ceduc-mackenzie",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "ceduc-mackenzie.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "325520837305",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:325520837305:web:460f44076c16c5a4d26968"
};

let app: FirebaseApp | null = null;
let auth: Auth | null = null;

export function getFirebaseAuth(): Auth {
  if (!app) {
    app = initializeApp(firebaseConfig);
  }
  if (!auth) {
    auth = getAuth(app);
    auth.languageCode = "pt-BR";
  }
  return auth;
}

export async function signInWithPassword(email: string, password: string): Promise<User> {
  const credential = await signInWithEmailAndPassword(getFirebaseAuth(), normalizeEmail(email), password);
  return credential.user;
}

export async function requestEmailSignInLink(email: string): Promise<void> {
  const normalizedEmail = normalizeEmail(email);
  const returnUrl = new URL(window.location.pathname || "/", window.location.origin);
  returnUrl.search = "";
  returnUrl.hash = "";

  await sendSignInLinkToEmail(getFirebaseAuth(), normalizedEmail, {
    url: returnUrl.toString(),
    handleCodeInApp: true
  });

  try {
    window.localStorage.setItem(EMAIL_FOR_SIGN_IN_KEY, normalizedEmail);
  } catch {
    // Se o armazenamento estiver bloqueado, o e-mail sera solicitado ao abrir o link.
  }
}

export function hasEmailSignInLink(url = window.location.href): boolean {
  return isSignInWithEmailLink(getFirebaseAuth(), url);
}

export function getStoredSignInEmail(): string {
  try {
    return normalizeEmail(window.localStorage.getItem(EMAIL_FOR_SIGN_IN_KEY) || "");
  } catch {
    return "";
  }
}

export async function completeEmailSignIn(email: string, url = window.location.href): Promise<User> {
  const credential = await signInWithEmailLink(getFirebaseAuth(), normalizeEmail(email), url);

  try {
    window.localStorage.removeItem(EMAIL_FOR_SIGN_IN_KEY);
  } catch {
    // A autenticacao concluida nao deve falhar por causa do armazenamento local.
  }

  window.history.replaceState({}, document.title, window.location.pathname || "/");
  return credential.user;
}

export async function signOutCurrentUser(): Promise<void> {
  await signOut(getFirebaseAuth());
}

function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}
